// extracted by mini-css-extract-plugin
export default {"countContainer":"codingTest_countContainer__O4tsD","subCountContainer":"codingTest_subCountContainer__KkP5f"};